import classnames from 'classnames';
import flattenDeep from 'lodash/flattenDeep';
import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch, withRouter } from 'react-router';
import { sortNodesBySortOrderFirst } from '../../../../utils/applyMenuConfigChanges/addSortOrderProperty/sortBySortOrder';
import { isBranch } from '../../../../utils/locationUtils';
import { NAV_TYPES } from '../../../LoggerFactory/BiAnalyticsLogger/events/consts';
import { getRelevantTree } from '../../App/utils';
import LibraryView from '../../LibraryView/LibraryView';
import LibraryViewForBots from '../../LibraryViewForBots/LibraryViewForBots';
import { getFirstItemHrefInSection } from '../../NavigationMenu/utils';
import { PageNotFound } from '../../PageElements/PageNotFound';
import { SEOCanonicalLink } from '../../PageElements/SEOCanonicalLink';
import { connectStore } from '../../../appContext/StoreProvider/ConnectStore';
import { TopContentBar } from '../TopContentBar';
import style from './MainContent.scss';
import { withExperiments } from '@wix/wix-experiments-react';
import { isClientSide } from '../../../../common/utils';

export class MainContent extends React.Component {
  static propTypes = {
    match: PropTypes.any,
    staticContext: PropTypes.any,
    location: PropTypes.any,
  };

  isBot = isClientSide() ? window.__IS_BOT__ : this.props.staticContext.isBot;

  withNotificationBar = isBranch(this.props.location) || this.props.isPreview;

  componentDidMount() {
    // TODO: IS THIS NECESSARY
    this.props.location.hash === '' &&
      this.props.store.publishToFocusLocation(
        getFirstItemHrefInSection('markdown', 0),
      );
  }

  renderRoutes = (tree, prefix) =>
    flattenDeep(
      Object.keys(tree).map((key) => {
        if (key === 'data' || !tree[key].data) {
          return [];
        }

        return [
          <Route
            key={`Route__/${prefix}${key}`}
            sensitive
            path={tree[key].data.link}
            render={(props) =>
              this.isBot ? (
                <LibraryViewForBots
                  {...props}
                  withNotificationBar={this.withNotificationBar}
                />
              ) : (
                <LibraryView
                  {...props}
                  withNotificationBar={this.withNotificationBar}
                />
              )
            }
          />,
        ];
      }),
    );

  renderFirstCategory = (props) => {
    const { store } = this.props;
    const tree = getRelevantTree(store);
    const firstCategoryKey = sortNodesBySortOrderFirst(tree)[0];

    return this.isBot ? (
      <LibraryViewForBots
        {...props}
        customPath={firstCategoryKey}
        withNotificationBar={this.withNotificationBar}
      />
    ) : (
      <LibraryView
        {...props}
        customPath={firstCategoryKey}
        withNotificationBar={this.withNotificationBar}
      />
    );
  };

  renderMainRoute = () => (
    <Route
      key="Route__/"
      exact
      path="/"
      component={(props) => (
        <div className={style.contentWrapper}>
          {this.renderFirstCategory(props)}
        </div>
      )}
    />
  );

  shouldRenderPageNotFound = () => {
    const { staticContext, location, store } = this.props;

    if (location.state && location.state.navType === NAV_TYPES.SCROLL) {
      return false;
    }

    if (!store.isPageExistInDocs(location.pathname)) {
      return true;
    }
    return staticContext && staticContext.statusCode === 404;
  };

  getAllRoutesElements = () => {
    const { store } = this.props;
    return [
      ...this.renderRoutes(store.docsTree, ''),
      ...this.renderRoutes(store.guidesTree, ''),
      this.renderMainRoute(),
    ];
  };

  render() {
    return (
      <main
        className={classnames({
          [style.page]: true,
          [style.relatedSitesAndSearchUi]:
            this.props.store.viewer?.viewerConfig?.relatedSites?.length > 1,
          [style.withNotificationBar]: this.withNotificationBar,
        })}
      >
        <SEOCanonicalLink staticContext={this.props.staticContext} />
        {this.shouldRenderPageNotFound() ? (
          <PageNotFound />
        ) : (
          <>
            <TopContentBar />
            <Switch>{this.getAllRoutesElements()}</Switch>
          </>
        )}
      </main>
    );
  }
}

export default withExperiments(withRouter(connectStore(MainContent)));
